module.exports = __webpack_public_path__ + "img/OLDegg_flames.aa226c6e.svg";